/**
 * Gemeinsames Anfrageformat und Prüfung der Backend-Annahme. Eine HTTP-Antwort
 * allein bedeutet noch keinen Versand: accepted muss ausdrücklich true sein.
 */
export type OfferScope = "planning" | "devices" | "installation";
export type OfferContact = {
  name: string;
  phone: string;
  email: string;
  street: string;
  postalCode: string;
  city: string;
};
export type ProjectOfferRequest = {
  requestId: string;
  projectId: string;
  projectName: string;
  scope: OfferScope;
  contact: OfferContact;
  verifiedAt: string;
  status: "draft" | "sent";
  sentAt?: string;
  backendRequestId?: string;
};

/** Only an explicit backend acceptance can produce a sent timestamp. */
export async function deliverProjectOffer(
  request: ProjectOfferRequest,
  post: (
    request: ProjectOfferRequest,
  ) => Promise<{ accepted: boolean; requestId?: string; sentAt?: string }>,
): Promise<ProjectOfferRequest> {
  if (request.status === "sent") return request;
  const reply = await post(request);
  if (reply.accepted !== true) throw new Error("Die Anfrage wurde vom Server nicht bestätigt.");
  return {
    ...request,
    status: "sent",
    sentAt:
      reply.sentAt && Number.isFinite(Date.parse(reply.sentAt))
        ? reply.sentAt
        : new Date().toISOString(),
    backendRequestId: reply.requestId,
  };
}
